<template>
	<div>
		<v-chart class="chart_market_value" :options="line" @datazoom='onDataZoom($event,line)'/>
		<b-alert show variant="light">
			<ul>
				<li>配合主图看，没啥大用</li>
			</ul>
		</b-alert>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import Moment from 'moment'

	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	// const downColor = '#00da3c';
	// const downBorderColor = '#008F28';

	export default {
		props: {
			title: {
				type: String,
				default: "市场结构周期2"
			},
			subText: {
				type: String,
				default: "年度大周期"
			},
			zoom_start: {
				type: [Number, String],
				default: 70,
			},
			zoom_end: {
				type: Number,
				default: 100,
			}
		},
		mounted() {
			this.refresh();
		},
		components: {
			'v-chart': ECharts
		},
		data() {
			return {
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					grid: [{
							left: '5%',
							right: '5%',
							height: '50%'
						},
						{
							left: '5%',
							right: '5%',
							top: '63%',
							height: '25%'
						}
					],
					xAxis: [{
						type: 'category',
						scale: true,
						boundaryGap: false,
						axisLine: {
							onZero: false,
							lineStyle: {
								color: '#666666'
							}
						},
						splitLine: {
							show: false
						},
						splitNumber: 10,
						min: 'dataMin',
						max: 'dataMax',
						axisPointer: {
							z: 100
						},
						axisLabel: {
							fontSize: 10,
							color: '#999999'
						},
					},
					{
						gridIndex: 1,
						type: 'category',
						scale: true,
						boundaryGap: false,
						axisLine: {
							onZero: false,
							lineStyle: {
								color: '#666666'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisLabel: {
							show: false
						},
						splitNumber: 20,
						min: 'dataMin',
						max: 'dataMax'
					}
					],
					yAxis: [{
						name: "分数",
						scale: true,
						position: 'right',
						min: 0,
						max: 'dataMax',
						splitNumber: 10,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							interval: 0,
							formatter: '{value}',
							color: '#999999'
						},
						lineStyle: {
							normal: {
								width: 1,
								opacity: 0.6,
								color: upBorderColor
							}
						},
						axisLine: { lineStyle: { color: '#666666' } },
						nameTextStyle: { color: '#999999' }
					},{
						gridIndex: 1,
						scale: true,
						offset: 2,
						position: 'right',
						splitNumber: 2,
						axisLabel: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						}],
					visualMap: {
						// top: 10,
						// right: 10,
						type: 'piecewise',
						show: false,
						seriesIndex: 0,
						dimension: 1,
						pieces: [{
								min: parseFloat(3000),
								color: upBorderColor
							},
							{
								min: parseFloat(2000),
								max: parseFloat(3000),
								color: upColor
							},
							{
								min: parseFloat(1000),
								max: parseFloat(2000),
								color: "#6667de"
							},
							{
								min: parseFloat(0),
								max: parseFloat(1000),
								color: "#cac500"
							},
						],
						outOfRange: {
							symbol: 'rect',
							symbolSize: [1, 1],
							color: upBorderColor,
						}
					},
					dataZoom: [{
						show: true,
						type: 'slider',
						xAxisIndex: [0, 1],
						y: '90%',
						start: this.zoom_start,
						end: this.zoom_end,
						textStyle: {
							color: '#999999'
						}
					}],
					series: [],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						borderWidth: 1,
						borderColor: '#ccc',
						padding: 10,
						textStyle: {
							// color: '#000'
						},
						// position: function (pos, params, el, elRect, size) {
						// 	var obj = {top: 10};
						// 	obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
						// 	return obj;
						// }
						// extraCssText: 'width: 170px'
					},
					axisPointer: {
						link: {xAxisIndex: 'all'},
						label: {
							backgroundColor: '#777'
						}
					},
				}
			}
		},
		methods: {
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data[i - j];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			refresh(data_start) {
				let url = '/v2/api/timing/market/style2?date1='
				if(data_start){
					url += data_start
				}else{
					url += (Moment().year()-2)+'-01-01'
				}
				// console.log(url)
				axios.all([
						request_zzquant({
							'url': url
						}),
					])
					.then(axios.spread((resp1) => {
						let splitDataItem = this.splitData(resp1['data']['data']);
						let series_data = []
						// console.log(splitDataItem);
						series_data.push({
							name: '市场得分',
							data: splitDataItem.trade_money_total,
							type: 'bar',
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
										type: 'average',
										name: '均值',
										symbol: 'circle',
									},
									{
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dotted",
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "牛市(2000)"
										},
										yAxis: 2000
									},
								]
							},
							markArea: {
								itemStyle: {
									color: 'rgba(255, 173, 177, 0.4)'
								},
								data: splitDataItem.timing_area_data
							}
						});
						
						series_data.push({
							name: 'MA10',
							data: this.calculateMA(10, splitDataItem.trade_money_total),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								}
							},
							symbol: 'circle',
						});
						
						series_data.push({
							name: 'positive',
							data: splitDataItem.up_count,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.3,
								}
							},
							// symbol: 'circle',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});
						series_data.push({
							name: 'up_count',
							data: splitDataItem.up_gt5_count,
							type: 'line',
							showSymbol: true,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.9,
									color: '#2530ff'
								}
							},
							symbol: 'circle',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});
						series_data.push({
							name: 'up_count_ever',
							data: splitDataItem.up_gt5_erver_count,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.4,
									color: '#2530ff'
								}
							},
							symbol: 'circle',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});
						series_data.push({
							name: 'turnover_ratio',
							data: splitDataItem.turnover_ratio,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.9,
									color: '#b83b53'
								}
							},
							symbol: 'circle',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});

						//设置数据，这里要设置2个，否则下面一行数据不显示，或者不能拖动配合xAxisIndex
						this.line['xAxis'] = [{
							data: splitDataItem.categoryData,
						},
						{
							data: splitDataItem.categoryData,
						}];
						this.line['series'] = series_data;
						this.line.legend = {
							data: ['市场得分','MA10'],
							textStyle: {
								color: '#999999'
							}
						};
						
					}))
					.catch(err => {
						console.log(err);
					})
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					// console.log(event.start)
					// console.log(event.end)
					let last_end = event.end
					// console.log(option.xAxis[0].data)
					if(event.start == 0){
						let data_start = option.xAxis[0].data[0]
						// console.log(data_start)
						let data_start_year = Moment(data_start).year()
						if(data_start_year<=2014){
							return
						}
						let data_start_new = (data_start_year-2)+'-01-01'
						// console.log(data_start_new)
						this.line.dataZoom[0].start=5
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
			splitData(rawData) {
				let [categoryData,trade_money_total,turnover_ratio,pe_ratio,market_cap_total,market_cap_circ_total,up_count,up_gt5_count,up_gt5_erver_count,timings,timing_area_data] = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]
				];
				//解构赋值
				let area_item = []
				rawData.forEach(item => {
					let item_date = item['date']
					categoryData.push(item_date);
					var item_trade_money_total = item['trade_money_total']
					var item_pe_ratio = item['pe_ratio']
					var item_market_cap_total = item['market_cap_total']
					var item_market_cap_circ_total = item['market_cap_circ_total']
					var item_up_count = item['up_count']
					var item_up_gt5_count = item['up_gt5_count']
					var item_up_gt5_erver_count = item['up_gt5_erver_count']
					let timing = item['timing']
					
					
					trade_money_total.push(item_trade_money_total);
					pe_ratio.push(item_pe_ratio);
					market_cap_total.push(item_market_cap_total);
					market_cap_circ_total.push(item_market_cap_circ_total);
					turnover_ratio.push((item_trade_money_total/item_market_cap_circ_total*100).toFixed(2));
					up_count.push(item_up_count)
					up_gt5_count.push(item_up_gt5_count)
					up_gt5_erver_count.push(item_up_gt5_erver_count)
					
					// 区域划分，N个区域，从第一个-1开始
					if(area_item.length==0){
						if(timing == -1){
							area_item.push(item_date);
						}
					}else{
						if(timing == 0){
							area_item.push(item_date);
							timings.push(area_item)
							area_item = []
						}else{
							//补漏,截止最后的数据未配对成功
							if(item_date == rawData[rawData.length-1]['date']){
								area_item.push(item_date);
								timings.push(area_item)
								area_item = []
							}
						}
					}
					
					timings.forEach(item=>{
						timing_area_data.push([{xAxis:item[0]},{xAxis:item[1]}])
					})
				})
				return {
					categoryData: categoryData,
					trade_money_total: trade_money_total,
					pe_ratio: pe_ratio,
					market_cap_total: market_cap_total,
					market_cap_circ_total: market_cap_circ_total,
					turnover_ratio:turnover_ratio,
					up_count:up_count,
					up_gt5_count:up_gt5_count,
					up_gt5_erver_count:up_gt5_erver_count,
					timings: timings,
					timing_area_data:timing_area_data
				};
			},
			// 最后在beforeDestroy()生命周期内清除定时器：
			beforeDestroy() {

			}
		}
	}
</script>

<style scoped>
	.chart_market_value {
		width: 100%;
		height: 400px;
	}
</style>
